import * as React from "react";
import { LeagueLabel } from "../..";
//import { createEmptyLabel } from ".";

export const renderLiveStreamLabel = (hasLiveEvents: boolean, text: string) => {
    return (
        hasLiveEvents ?
            <LeagueLabel className="rj-league-list__live-stream-label" text={text} />
            : <></>
    )
}